import { jsx as _jsx } from "react/jsx-runtime";
import { Diamonds, MagicStar, User } from "iconsax-react";
import { Icon } from "@iconify/react";
import Grid from "@mui/material/Grid2";
import { DirectorsInvitationStatCard } from "@ui/components/cards/DirectorsInvitationStats";
import { useAppSelector } from "@application/store/useStore";
import { InvitationStatusEnum } from "@application/common/enums/invitation-status-enum";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const statCards = [
    {
        id: "grandAttendees",
        icon: _jsx(Diamonds, {}),
        title: "grandTotal",
        showIn: "both",
        clickAllowed: true,
        searchParam: "all",
    },
    {
        id: "totalAttendees",
        icon: _jsx(Diamonds, {}),
        title: "totalAttendees",
        showIn: "both",
        clickAllowed: true,
        invitationStatus: InvitationStatusEnum.Registered,
    },
    {
        id: "registered",
        icon: _jsx(Icon, { icon: "eva:checkmark-outline", width: "20", height: "20" }),
        title: "registered",
        active: true,
        showIn: "both",
        clickAllowed: true,
        invitationStatus: InvitationStatusEnum.Registered,
    },
    {
        id: "invited",
        icon: _jsx(MagicStar, {}),
        title: "invited",
        showIn: "both",
        clickAllowed: true,
        invitationStatus: InvitationStatusEnum.Invited,
    },
    {
        id: "inProgress",
        icon: _jsx(Icon, { icon: "eva:loader-outline" }),
        title: "inProgress",
        showIn: "both",
        clickAllowed: true,
        invitationStatus: InvitationStatusEnum.InProgress,
    },
    {
        id: "agreedToAccommodationCount",
        icon: _jsx(User, {}),
        title: "Accommodation",
        showIn: "directors",
        clickAllowed: true,
        searchParam: "accommodation",
    },
    {
        id: "agreedToTransportCount",
        icon: _jsx(Diamonds, {}),
        title: "Transport",
        showIn: "directors",
        clickAllowed: true,
        searchParam: "transport",
    },
    {
        id: "adults",
        icon: _jsx(User, {}),
        title: "adults",
        showIn: "family",
        clickAllowed: true,
        searchParam: "adult",
    },
    {
        id: "children",
        icon: _jsx(User, {}),
        title: "children",
        showIn: "family",
        clickAllowed: true,
        searchParam: "child",
    },
];
export const InvitationStatList = ({ eventType, onStatusChange, onParamChange, }) => {
    const { invitationStats } = useAppSelector((state) => state.invitation);
    const [activeCardId, setActiveCardId] = useState(null);
    const { t } = useTranslation();
    const handleCardClick = (id, clickAllowed, invitationStatus, searchParam) => {
        if (clickAllowed) {
            const newActiveId = activeCardId === id ? null : id;
            setActiveCardId(newActiveId);
            onStatusChange?.(newActiveId ? (invitationStatus ?? null) : null);
            onParamChange?.(newActiveId ? (searchParam ?? null) : null);
        }
    };
    const filteredStats = statCards.filter((card) => card.showIn === "both" || card.showIn === eventType);
    return (_jsx(Grid, { container: true, spacing: 2, sx: { display: "flex" }, children: filteredStats.map(({ id, icon, title, clickAllowed, invitationStatus, searchParam }) => {
            const value = invitationStats && invitationStats[id] != 0
                ? invitationStats[id]
                : 0;
            const isClickable = clickAllowed && value > 0;
            return (_jsx(Grid, { size: { xs: 6, sm: 4, md: 3, lg: 1.7 }, children: _jsx(DirectorsInvitationStatCard, { Icon: icon, title: t(`admin.stats.${title}`), value: value, active: activeCardId === id, onClick: () => isClickable &&
                        handleCardClick(id, clickAllowed, invitationStatus, searchParam), clickable: isClickable }) }, id));
        }) }));
};
